export class WorkflowErrorMessages {
    // Static methods for creating consistent error messages across multiple components.
    public static duplicateWorkflowInSiteMessage(workflowName: string, siteId: number): string {
        let message: string = `Cannot save this workflow as '${workflowName}' as a workflow with that name already exists in the current site.`;

        return message;
    }
}
